import { render, staticRenderFns } from "./gift_box.vue?vue&type=template&id=b71abd92&scoped=true&"
import script from "./gift_box.vue?vue&type=script&lang=js&"
export * from "./gift_box.vue?vue&type=script&lang=js&"
import style0 from "./gift_box.vue?vue&type=style&index=0&id=b71abd92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../wx-ktv-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71abd92",
  null
  
)

export default component.exports